<template>
  <div :id="description.title.trim().replaceAll(' ','-').toLowerCase()" class="description">
    <div class="text row full-width" :class="{reverse}">
      <div class="text-part g-16">
        <Heading tag="h3" font-size="20px">{{ description.title }}</Heading>
        <div class="body" v-html="description.body"></div>
      </div>
      <div class="description-file">
        <img loading="lazy" :alt="description.file_title" :title="description.file_title" :src="description.file">
        <span class="file-title">{{ description.file_title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from "~/components/atoms/Heading.vue";

export default {
  components: {Heading},
  props: {
    description: Object,
    reverse: Boolean
  }
}
</script>

<style scoped lang="scss">
.description-file {
  min-width: 468px;
  max-width: 468px;

  @include smd {
    min-width: 100%;
    max-width: 100%;
  }
}

img {
  width: 100%;
}

.text {
  gap: 157px;

  @include smd {
    flex-direction: column;
    gap: 32px;
  }
}

.text.reverse {
  flex-direction: row-reverse;

  @include smd {
    flex-direction: column;
  }
}

.file-title {
  position: absolute;
  bottom: 20px;
  height: 35px;
  background: $space-black;
  box-shadow: 0 4px 25px rgba(43, 43, 43, .35);
  color: $white;
  padding: 0 24px;
  display: flex;
  align-items: center;
  font-weight: 500;
  text-transform: uppercase;
  left: -8px;
  letter-spacing: .055em;
}

.body {
  line-height: 25px;
}
</style>
